import { z } from "zod";

export const genderEnum = z.enum([ "BOY", "GIRL", "UNKNOWN" ]);

export const breedEnum = z.enum([
  "DOMESTIC_SHORT_HAIR",
  "DOMESTIC_MEDIUM_HAIR",
  "DOMESTIC_LONG_HAIR",
  "ABYSSINIAN",
  "AMERICAN_BOBTAIL",
  "AMERICAN_CURL",
  "AMERICAN_SHORTHAIR",
  "BALINESE",
  "BENGAL",
  "BIRMAN",
  "BRITISH_SHORTHAIR",
  "BRITISH_LONGHAIR",
  "BURMESE",
  "BURMILLA",
  "CHAUSIE",
  "CHINCHILLA",
  "CORNISH_REX",
  "DEVON_REX",
  "EXOTIC_SHORTHAIR",
  "JAPANESE_BOBTAIL",
  "KORAT",
  "KURILIAN_BOBTAILS",
  "LAPERM",
  "MAINE_COON",
  "MANX",
  "MOGGIE",
  "NORWEGIAN_FOREST_CAT",
  "OCICAT",
  "ORIENTAL_SHORTHAIR",
  "PERSIAN",
  "PETERBALD",
  "PIXIE_BOB",
  "RAGAMUFFIN",
  "RAGDOLL",
  "RUSSIAN_BLUE",
  "SAVANNAH",
  "SCOTTISH_FOLD",
  "SIAMESE",
  "SIBERIAN_FOREST_CAT",
  "SINGAPURA",
  "SNOWSHOE",
  "SOMALI",
  "SPHYNX",
  "TIFFANIE",
  "TONKINESE",
  "TURKISH_ANGORA",
  "TURKISH_VAN",
  "OTHER",
  "I_DONT_KNOW_THEIR_BREED",
  "UNKNOWN",
]);

export const ageTypeEnum = z.enum([ "kitten", "adult", "senior" ]);

export const catBodyTypeEnum = z.enum([
  "SKINNY",
  "JUST_RIGHT",
  "CHUBBY",
  "OBESE",
  "UNKNOWN",
]);
export type TSufBodyType = Exclude<z.infer<typeof catBodyTypeEnum>, "UNKNOWN">;

export const catActivityLevelEnum = z.enum([
  "INACTIVE",
  "ACTIVE",
  "EXPLORER",
  "UNKNOWN",
]);
export type TSufActivityLevel = Exclude<z.infer<typeof catActivityLevelEnum>, "UNKNOWN">;

export const catFussinessEnum = z.enum([
  "NOT_FUSSY",
  "QUITE_FUSSY",
  "VERY_FUSSY",
  "UNKNOWN",
]);
export type TCatFussiness = z.infer<typeof catFussinessEnum>;
export const CatFussiness = catFussinessEnum.enum;
export const isCatFussiness = (value: unknown): value is TCatFussiness => typeof value === "string" &&
    Object.values(CatFussiness).includes(value as TCatFussiness);

export const catFoodTypeBeforeEnum = z.enum([
  "DRY",
  "WET",
  "RAW",
  "HOME_COOKED",
  "FRESH",
]);
export type TCatFoodTypeBefore = z.infer<typeof catFoodTypeBeforeEnum>;
export const CatFoodTypeBefore = catFoodTypeBeforeEnum.enum;

export const catBrandBeforeEnum = z.enum([
  "FELIX",
  "WHISKAS",
  "GOURMET",
  "SHEBA",
  "ROYAL_CANIN",
  "PURINA_ONE",
  "APPLAWS",
  "AARDVARK",
  "ALMO_NATURE",
  "AVA",
  "BLINK",
  "BURNS",
  "CARNILOVE",
  "CRAVE",
  "EDGARD_COOPER",
  "ENCORE",
  "FERINGA",
  "FRESHPET",
  "GO_CAT",
  "HARRINGTONS",
  "HILLS",
  "IAMS",
  "JAMES_WELLBELOVED",
  "KATKIN",
  "LILYS_KITCHEN",
  "MEOWING_HEADS",
  "NATURAL_INSTINCT",
  "NATURES_MENU",
  "NUTRIMENT",
  "ORIJEN",
  "PURR_AND_MIAOW",
  "PURRFORM",
  "REPUBLIC_OF_CATS",
  "SCRUMBLES",
  "SUPERMARKET_BRAND",
  "THRIVE",
  "TOMOJO",
  "UNTAMED",
  "MARRO",
  "OTHER",
  "UNKNOWN",
]);
export type TCatBrandBefore = z.infer<typeof catBrandBeforeEnum>;
export const CatBrandBefore = catBrandBeforeEnum.enum;

export const allergenEnum = z.enum([
  "CHICKEN",
  "TURKEY",
  "BEEF",
  "PORK",
  "LAMB",
  "WHITEFISH",
  "DUCK",
  "SALMON",
  "TUNA",
]);
export type TAllergen = z.infer<typeof allergenEnum>;
export const Allergen = allergenEnum.enum;

export const catMedicalConditionEnum = z.enum([
  "A_FOOD_ALLERGY",
  "INFLAMMATORY_BOWEL_DISEASE",
  "DIABETES",
  "KIDNEY_DISEASE",
  "URINARY_DISEASE",
  "DIARRHOEA_OF_AN_UNKNOWN_CAUSE",
  "VOMITING_OF_AN_UNKNOWN_CAUSE",
  "HYPERTHYROIDISM",
  "PANCREATITIS",
  "CYSTITIS",
  "ARTHRITIS",
  "LIVER_DISEASE",
  "FELINE_ASTHMAS",
  "EPILEPSY",
  "CANCER",
  "OTHER",
]);
export type TCatMedicalCondition = z.infer<typeof catMedicalConditionEnum>;
export const CatMedicalCondition = catMedicalConditionEnum.enum;

export const personaEnum = z.enum([
  "INGREDIENT_INVESTIGATOR",
  "VET_GUIDED_CAREGIVER",
  "INDULGENT_OWNER",
  "VALUE_MAINSTREAMER",
  "SUBSCRIPTION_SEEKER",
  "CASUAL_CAT_OWNER",
]);
export type TPersona = z.infer<typeof personaEnum>;
export const Persona = personaEnum.enum;

export const birthdayMonthEnum = z.enum([
  "JANUARY",
  "FEBRUARY",
  "MARCH",
  "APRIL",
  "MAY",
  "JUNE",
  "JULY",
  "AUGUST",
  "SEPTEMBER",
  "OCTOBER",
  "NOVEMBER",
  "DECEMBER",
]);
export type TBirthdayMonth = z.infer<typeof birthdayMonthEnum>;

export const catWeightUnitEnum = z.enum([ "KG", "LB" ]);
export type TCatWeightUnit = z.infer<typeof catWeightUnitEnum>;

export const ageModeEnum = z.enum([ "years", "months", "weeks" ]);
export type TAgeMode = z.infer<typeof ageModeEnum>;
export type TKittenAgeMode = Exclude<TAgeMode, "years">;

export const pricingPlanEnum = z.enum([
  "HALF",
  "STANDARD",
  "FREEZER",
  "SAVER",
  "TRIAL",
  "TRIAL_WEEK",
]);
export type TPricingPlan = z.infer<typeof pricingPlanEnum>;
export const PricingPlan = pricingPlanEnum.enum;

export const discountCodeTypeEnum = z.enum([
  "PERCENTAGE",
  "FIXED_AMOUNT",
  "ABSOLUTE_TOTAL",
]);
export type TDiscountCodeType = z.infer<typeof discountCodeTypeEnum>;
export const DiscountCodeType = discountCodeTypeEnum.enum;

export const freshMealPlanTypeEnum = z.enum([
  "FRESH",
  "FRESH_TRIAL",
  "FRESH_CROSS_SELL",
]);

export const recipeProductTitleEnum = z.enum([
  "BAAA",
  "CLUCK",
  "MOOO",
  "SPLASH",
  "GOBBLE",
  "QUACK",
  "OINK",
  "SHREDDED_CLUCK",
  "SHREDDED_GOBBLE",
  "SWISH",
]);

// Tubes are still needed here so they can be migrated to pouches later via normalisation.
export const nibblesProductTitleEnum = z.enum([
  "NIBBLES_CHICKEN",
  "NIBBLES_SALMON",
  "NIBBLES_TRIO_BUNDLE",
]);
export type TNibblesProductTitle = z.infer<typeof nibblesProductTitleEnum>;

export const sprinklesProductTitleEnum = z.enum([ "SPRINKLES" ]);
